import { IonicButton } from 'ionic-ui';
import React from 'react';

type ActionConfirmationDialogProps = {
  title?: string;
  message?: string;
  confirmText?: string;
  confirmationType?: 'destructive' | 'default';
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
};

const ActionConfirmationDialog: React.FC<ActionConfirmationDialogProps> = ({
  title = 'Confirm Action',
  message = 'Are you sure you want to continue?',
  confirmText = 'Confirm',
  confirmationType = 'destructive',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="space-y-4 sm:max-w-[480px] dialog-content">
      <div>
        {title && <h5 className="mb-2 font-semibold">{title}</h5>}
        {message && <p className="mb-6 text-gray-700">{message}</p>}
      </div>

      <div className="flex items-center flex-wrap w-full gap-2">
        {onCancel && (
          <IonicButton
            type="button"
            onClick={onCancel}
            variant="outline"
            className="flex-1 min-w-fit"
          >
            {cancelText}
          </IonicButton>
        )}
        {onConfirm && (
          <IonicButton
            type="button"
            onClick={onConfirm}
            className={`${confirmationType === 'destructive' ? 'destructive-button' : ''} flex-1 min-w-fit`}
          >
            {confirmText}
          </IonicButton>
        )}
      </div>
    </div>
  );
};

export default ActionConfirmationDialog;
